import angular from 'angular'

export default angular.module('outputManage.FOManage.invoice', [])



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoice1/module.js